import { GzBlocklistRulesGeneralWebComponent } from './component/GzBlocklistRulesGeneralWebComponent';

export { GzBlocklistRulesGeneralWebComponent };
